import { render, staticRenderFns } from "./NewTempMember.vue?vue&type=template&id=06b31f64&"
import script from "./NewTempMember.vue?vue&type=script&lang=js&"
export * from "./NewTempMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports